import { createFeature, createReducer, on } from '@ngrx/store';
import { forgotPinAction } from './forgot-pin.action';

export interface ForgotPinState {
  loading: boolean;
  error: string | null;
  lastEmail: string | null;
  otpToken: string | null;
  veritifyToken: string | null;
  resendDelaySeconds: number;
  twoFactorAuthMethod: 'OTP' | 'TOTP' | string | null;
}

const initialState: ForgotPinState = {
  loading: false,
  error: null,
  lastEmail: null,
  otpToken: null,
  veritifyToken: null,
  resendDelaySeconds: 30,
  twoFactorAuthMethod: null,
};

const reducer = createReducer(
  initialState,
  on(
    forgotPinAction.requestUserEmail,
    (state: ForgotPinState): ForgotPinState => ({
      ...state,
      error: null,
      veritifyToken: null,
      otpToken: null,
      loading: false,
    })
  ),
  on(
    forgotPinAction.requestUserEmailSucess,
    (state: ForgotPinState, { email }): ForgotPinState => ({
      ...state,
      loading: false,
      lastEmail: email,
    })
  ),
  on(
    forgotPinAction.requestOtpFailed,
    (state: ForgotPinState, { error }): ForgotPinState => ({
      ...state,
      loading: false,
      otpToken: null,
      veritifyToken: null,
      error: error,
    })
  ),
  on(
    forgotPinAction.requestOtpSuccess,
    (
      state: ForgotPinState,
      { email, otpToken, resendDelaySeconds, twoFactorAuthMethod }
    ): ForgotPinState => ({
      ...state,
      loading: false,
      lastEmail: email,
      otpToken: otpToken,
      error: null,
      veritifyToken: null,
      resendDelaySeconds: resendDelaySeconds || 30,
      twoFactorAuthMethod: twoFactorAuthMethod || null,
    })
  ),
  on(
    forgotPinAction.requestOtp,
    (state: ForgotPinState): ForgotPinState => ({
      ...state,
      loading: true,
      error: null,
    })
  ),
  on(
    forgotPinAction.requestOtpValidationFailed,
    (state: ForgotPinState, { error }): ForgotPinState => ({
      ...state,
      loading: false,
      error: error,
    })
  ),
  on(
    forgotPinAction.requestOtpValidationSuccess,
    (state: ForgotPinState, { otpToken }): ForgotPinState => ({
      ...state,
      loading: false,
      veritifyToken: otpToken,
    })
  )
);

export const forgotPinFeature = createFeature({
  name: 'Forgot Pin',
  reducer: reducer,
});
